module.exports = __webpack_public_path__ + "img/news6.2e3c6121.svg";